import { Radio as MUIRadio, RadioGroup as MUIRadioGroup } from '@mui/material';
import styled, { css } from 'styled-components';

import { FormControlLabel } from '../form';

export const StyledRadio = styled(MUIRadio)<{ checked?: boolean }>`
  padding: 0;
  margin-right: 12px;

  svg {
    overflow: visible;
  }
`;

export const RadioContainer = styled.div`
  grid-column: span 1;
`;

export const StyledRadioFormControlLabel = styled(FormControlLabel)`
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 0;

  .MuiFormControlLabel-label {
    font: var(--font-small-13pt-normal);
  }
`;

type StyledRadioGroupProps = {
  $labelPlacement?: 'top';
  $variant: 'boolean' | 'booleanString' | 'default';
};

export const StyledRadioGroup = styled(MUIRadioGroup)<StyledRadioGroupProps>`
  ${({ $labelPlacement }) =>
    $labelPlacement === 'top' &&
    css`
      align-self: flex-start;
    `}
  ${({ $variant }) => css`
    ${$variant === 'boolean' && booleanStyles}
    ${$variant === 'booleanString' && booleanStyles}
    ${$variant === 'default' && defaultStyles}
  `}
`;

const booleanStyles = css`
  gap: 48px;
  display: flex;
  flex-direction: row;
  grid-column: 2 / span 3;
`;

const defaultStyles = css`
  display: grid;
  grid-column: 2 / span 3;
  grid-template-columns: repeat(3, 1fr);
  width: 100%;
  align-items: center;
  grid-column-gap: var(--sizes-60);
`;
